import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ArthaGateway from 'service/ArthaGateway';
import { CreditNote, Sale, SaleOrder, Receipt, VoucherSummary } from 'service';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { faFileInvoice, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { durations } from 'service/Utils';
import { useNavigate } from 'react-router';

export const Invoices = () => {
    const appdata = useSelector((state: RootState) => state.appdata);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [durationId, setDurationId] = useState<string>("4");
    const [sales, setSales] = useState<Sale[]>([]);
    const [orders, setOrders] = useState<SaleOrder[]>([]);
    const [creditNotes, setCreditNotes] = useState<CreditNote[]>([]);
    const [receipts, setReceipts] = useState<Receipt[]>([]);
    const [voucherSummary, setVoucherSummary] = useState<VoucherSummary>();
    const [voucherType, setVoucherType] = useState<string>("sale");
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [paymentStatus, setPaymentStatus] = useState<number>(0);
    const [deliveryStatus, setDeliveryStatus] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(5);
    const [orderSummary, setOrderSummary] = useState<any[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (voucherType === "sale") {
            loadSales();
        }
        else if (voucherType === "order") {
            loadOrders();
        }
        else {
            loadCreditNotes();
        }
    }, [pageNumber]);

    useEffect(() => {
        setSales([]);
        setOrders([]);
        setReceipts([]);
        setCreditNotes([]);
        setPageNumber(1);

        if (voucherType === "sale") {
            loadSalesSummary();
            loadSales();
        }
        else if (voucherType === "order") {
            loadOrderSummary();
            loadOrders();
        }
        else {
            loadCreditNotesSummary();
            loadCreditNotes();
        }
    }, [durationId, voucherType, paymentStatus, deliveryStatus]);

    const loadSales = () => {
        setIsLoading(true);
        ArthaGateway
            .getSales(0, durationId, paymentStatus, deliveryStatus, pageNumber, pageSize)
            .then((data) => {
                data.entries.map((sale: any) => sale.isExpanded = false);
                if (pageNumber > 1) {
                    setSales(sales.concat(data.entries));
                }
                else {
                    setSales(data.entries);
                }
                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadSalesSummary = () => {
        setIsLoading(true);
        ArthaGateway
            .getSalesSummary(0, durationId, paymentStatus, deliveryStatus)
            .then((data) => {
                setVoucherSummary(data);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadOrders = () => {
        setIsLoading(true);
        ArthaGateway
            .getOrders(appdata.profile.profile.partyId, durationId, 0, 0, pageNumber, pageSize)
            .then((data) => {
                data.entries.map((order: any) => order.isExpanded = false);
                if (pageNumber > 1) {
                    setOrders(orders.concat(data.entries));
                }
                else {
                    setOrders(data.entries);
                }

                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadOrderSummary = () => {
        setIsLoading(true);
        ArthaGateway
            .getOrdersSummary(appdata.profile.profile.partyId, durationId, 0, 0)
            .then((data) => {
                let d = {
                    "numberOfInvoices": data.numberOfIvoices,
                    "billAmount": data.billAmount,
                }
                let orderSummary = [
                    {
                        "statusCode": 1,
                        "status": "Pending",
                        "count": 0,
                    },
                    {
                        "statusCode": 2,
                        "status": "Partial",
                        "count": 0,
                    },
                    {
                        "statusCode": 3,
                        "status": "Fullfilled",
                        "count": 0,
                    },
                    {
                        "statusCode": 4,
                        "status": "Cancelled",
                        "count": 0,
                    }
                ];
                data.statusSummary.map((orderStatus: any) => {
                    orderSummary.map((summary) => {
                        if (summary.statusCode === orderStatus.status) {
                            summary.count = orderStatus.count;
                        }
                    });
                });
                setOrderSummary(orderSummary);
                setVoucherSummary(d);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadCreditNotes = () => {
        setIsLoading(true);
        ArthaGateway
            .getCreditNotes(appdata.profile.profile.partyId, durationId, 0, pageNumber, pageSize)
            .then((data) => {
                data.entries.map((receipt: any) => receipt.isExpanded = false);
                setCreditNotes(creditNotes.concat(data.entries));
                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadCreditNotesSummary = () => {
        setIsLoading(true);
        ArthaGateway
            .getCreditNotesSummary(appdata.profile.profile.partyId, durationId, 0)
            .then((data) => {
                setVoucherSummary(data);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const toggleExapnd = (target: any) => {
        if (voucherType === "sale") {
            sales.map((sale) => {
                if (sale.id === target.id) {
                    sale.isExpanded = !sale.isExpanded;
                }
                else {
                    sale.isExpanded = false;
                }
            });
            setSales([...sales]);
        }
        else if (voucherType === "order") {
            orders.map((order) => {
                if (order.id === target.id) {
                    order.isExpanded = !order.isExpanded;
                }
                else {
                    order.isExpanded = false;
                }
            });
            setOrders([...orders]);
        }
        else if (voucherType === "receipt") {
            receipts.map((receipt) => {
                if (receipt.id === target.id) {
                    receipt.isExpanded = !receipt.isExpanded;
                }
                else {
                    receipt.isExpanded = false;
                }
            });
            setReceipts([...receipts]);
        }
        else {
            creditNotes.map((creditNote) => {
                if (creditNote.id === target.id) {
                    creditNote.isExpanded = !creditNote.isExpanded;
                }
                else {
                    creditNote.isExpanded = false;
                }
            });
            setCreditNotes([...creditNotes]);
        }
    }

    const sendWhatsAppMessage = (sale: Sale) => {
        ArthaGateway
            .getSalesFileLink(sale.id)
            .then((url) => {
                const message = "Dear " + sale.party.name + ",\r\nYour invoice *" + sale.voucherNumber + "* with amount *" + currencyFormat(sale.billAmount) + "/-* is ready. \r\nView details here " + url + ".\r\n\r\nThanks & Regards,\r\nAmruth Organic Fertilizers, Malladihalli";
                let whatsappUrl = 'https://wa.me/+91'
                    + sale.party.mobileNumber
                    + '?text='
                    + encodeURIComponent(message);
                window.open(whatsappUrl, "_blank");
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const viewInvoice = (sale: Sale) => {
        navigate("/invoice/" + sale.id);
    }

    const printInvoice = (sale: Sale) => {
        let url = process.env.REACT_APP_SERVER_URL + "/voucher/sale/print/" + sale.id;
        let companyCode = localStorage.getItem("Company-code");
        if (companyCode) {
            url += "?print=1&companyCode=" + companyCode;
        }
        window.open(url, "_blank");
    }

    const viewOrderData = (salesOrder: SaleOrder) => {
        ArthaGateway
            .getSalesOrderFileLink(salesOrder.id)
            .then((url) => {
                window.open(url, "_blank");
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const viewReceiptData = (receipt: Receipt) => {
        ArthaGateway
            .getReceiptFileLink(receipt.id)
            .then((url) => {
                window.open(url, "_blank");
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const viewCreditNoteData = (creditNote: CreditNote) => {
        ArthaGateway
            .getCreditNoteFileLink(creditNote.id)
            .then((url) => {
                window.open(url, "_blank");
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }


    const currencyFormat = (value: number) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page-vouchers app-page-shell'>
            {/*<ul className="nav">
                <li className="nav-item" onClick={() => setVoucherType("sale")}>
                    <h2 className={(voucherType === "sale") ? "nav-link active" : "nav-link"}>Invoices</h2>
                </li>
                <li className="nav-item" onClick={() => setVoucherType("order")}>
                    <h2 className={(voucherType === "order") ? "nav-link active" : "nav-link"}>Orders</h2>
                </li>
                <li className="nav-item" onClick={() => setVoucherType("receipt")}>
                    <h2 className={(voucherType === "receipt") ? "nav-link active" : "nav-link"}>Receipts</h2>
                </li>
                {appdata && appdata.profile.profile && appdata?.profile?.profile?.enableCreditNote &&
                    <li className="nav-item" onClick={() => setVoucherType("credit_note")}>
                        <h2 className={(voucherType === "credit_note") ? "nav-link active" : "nav-link"}>Credit Notes</h2>
                    </li>
                }
            </ul>*/}
            <div className='list-page-hero mb-3'>
                <div>
                    <div className='hero-label'>Sales</div>
                    {(voucherType === "sale") &&
                        <h2>Invoices</h2>
                    }
                    {/*<p>Track invoices by duration, payment, and delivery status.</p>*/}
                </div>
                <div className='hero-actions'>
                    <button type='button' className='btn btn-light btn-sm' onClick={() => navigate('/customers')}>Create Invoice</button>
                </div>
            </div>
            <div className='app-panel mb-3'>
                <div className="row">
                    <div className="col-6 col-md-4 mb-2">
                        <div className='form-group'>
                            <label>Duration</label>
                            <select className="form-select" id="duration" value={durationId} onChange={(e) => setDurationId(e.target.value)}>
                                {durations.map((duration) => (
                                    <option key={duration.value} value={duration.value}>{duration.label}</option>
                                ))}
                                <option value="-1">Other</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 mb-2">
                        <div className='form-group'>
                            <label>Payment Status</label>
                            <select className="form-select" id="voucherType" value={paymentStatus} onChange={(e) => setPaymentStatus(parseInt(e.target.value))}>
                                <option value="0">All</option>
                                <option value="1">Pending</option>
                                <option value="2">Paid</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-6 col-md-4 mb-2">
                        <div className='form-group'>
                            <label>Delivery Status</label>
                            <select className="form-select" id="voucherType" value={deliveryStatus} onChange={(e) => setDeliveryStatus(parseInt(e.target.value))}>
                                <option value="0">All</option>
                                <option value="1">Pending</option>
                                <option value="2">Packed</option>
                                <option value="3">Delivered</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className='page-invoice-list app-panel'>
                {(voucherType === "order") &&
                    <div className="row g-2 mb-3">
                        {orderSummary && orderSummary.map((summary) => (
                            <div className="col-6 col-md-3">
                                <div className="card shadow bg-light">
                                    {summary.status}
                                    <div className="inner">
                                        <h4>{summary.count}</h4>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                }
                {(voucherType !== "order") &&
                    <div className="row g-2 mb-3">
                        <div className="col-4">
                            <div className="summary-card">
                                <div className="label">Invoices</div>
                                <div className="value">{voucherSummary?.numberOfInvoices}</div>
                            </div>
                        </div>
                        <div className="col-8">
                            <div className="summary-card">
                                <div className="label">Amount</div>
                                <div className="value">{currencyFormat((voucherSummary?.billAmount) ? voucherSummary?.billAmount : 0)}</div>
                            </div>
                        </div>
                    </div>
                }
                <div className="accordion voucher-accordion" id="dealerAccordion">
                    {sales && sales.map((sale) => (
                        <div className="accordion-item">
                            <h2 className="accordion-header" id={sale.id.toString()} onClick={() => toggleExapnd(sale)}>
                                <div className={sale.isExpanded === true ? "accordion-button active bg-dark" : "accordion-button collapsed"}>
                                    <div className='w-100'>
                                        <b>{sale.party.name}</b>
                                        <div className='float-end' style={{ marginRight: "15px" }}>{currencyFormat(sale.billAmount)}/-</div>
                                        <div className="date-info">{sale.voucherNumber} - {moment(sale.date).fromNow()}</div>
                                    </div>
                                </div>
                            </h2>
                            <div id={"d" + sale.id.toString()} className={sale.isExpanded === true ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby={"d" + sale.id.toString()}>
                                <div className="accordion-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">
                                            Invoice Number
                                            <div className="fw-bold">{sale.voucherNumber}</div>
                                        </li>
                                        <li className="list-group-item">
                                            Date
                                            <div className="fw-bold">{moment(sale.date).format("DD/MM/YYYY")}</div>
                                        </li>
                                        <li className="list-group-item">
                                            Customer
                                            <div className="fw-bold">{sale.party.name}</div>
                                        </li>
                                        <li className="list-group-item">
                                            <div>Status</div>
                                            {sale.status == 1 &&
                                                <div className='badge bg-danger'>Pending</div>
                                            }
                                            {sale.status == 2 &&
                                                <div className='badge bg-primary'>Packed</div>
                                            }
                                            {sale.status == 3 &&
                                                <div className='badge bg-success'>Delivered</div>
                                            }
                                        </li>
                                        <li className="list-group-item">
                                            Bill Amount
                                            <div className="fw-bold">{currencyFormat(sale.billAmount)}/-</div>
                                        </li>
                                        {sale.pendingAmount > 0 &&
                                            <li className="list-group-item">
                                                Pending Amount
                                                <div className="fw-bold">{currencyFormat(sale.pendingAmount)}/-</div>
                                            </li>
                                        }
                                    </ul>
                                    <div className="btn-group d-flex" role="group" style={{ marginTop: 10 }}>
                                        <div className="btn btn-dark w-100" title="View" onClick={() => viewInvoice(sale)}>
                                            <FontAwesomeIcon icon={faFileInvoice} style={{ width: "auto" }} />
                                            &nbsp; View
                                        </div>
                                        <div className="btn btn-dark w-100" title="View" onClick={() => printInvoice(sale)}>
                                            <FontAwesomeIcon icon={faPrint} style={{ width: "auto" }} />
                                            &nbsp; Print
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {orders && orders.map((order) => (
                        <div className="accordion-item">
                            <h2 className="accordion-header" id={order.id.toString()} onClick={() => toggleExapnd(order)}>
                                <div className={order.isExpanded === true ? "accordion-button active bg-dark" : "accordion-button collapsed"}>
                                    <div style={{ position: "relative" }}>
                                        <b>{order.voucherNumber}</b>
                                        {moment(order.date).isSame(moment(), 'day') &&
                                            <div className='badge bg-success badge-small badge-notice'>Today</div>
                                        }
                                        {moment(order.date).isSame(moment().add(-1, 'days'), 'day') &&
                                            <div className='badge bg-primary badge-small badge-notice'>Yesterday</div>
                                        }
                                        {order.status === 1 &&
                                            <div className='badge bg-danger badge-notice'>Pending</div>
                                        }
                                        {order.status === 2 &&
                                            <div className='badge bg-info badge-notice'>Patial</div>
                                        }
                                        {order.status === 3 &&
                                            <div className='badge bg-success badge-notice'>Fullfilled</div>
                                        }
                                        {order.status === 4 &&
                                            <div className='badge bg-danger badge-notice'>Cancelled</div>
                                        }
                                        <div style={{ fontWeight: 'normal', fontSize: '0.8rem' }}>{currencyFormat(order.billAmount)}/-</div>
                                        <div className="date-info">{moment(order.date).format("DD MMM YYYY")}</div>
                                    </div>

                                </div>
                            </h2>
                            <div id={"o" + order.id.toString()} className={order.isExpanded === true ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby={"o" + order.id.toString()}>
                                <div className="accordion-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">
                                            Bill Amount
                                            <div className="fw-bold">{currencyFormat(order.billAmount)}/-</div>
                                        </li>
                                    </ul>
                                    <div className="btn-group d-flex" role="group" style={{ marginTop: 10 }}>
                                        <div className="btn btn-dark w-100" title="View" onClick={() => viewOrderData(order)}>
                                            <FontAwesomeIcon icon={faFileInvoice} style={{ width: "auto" }} />
                                            &nbsp; Download Order
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {creditNotes && creditNotes.map((creditNote) => (
                        <div className="accordion-item">
                            <h2 className="accordion-header" id={creditNote.id.toString()} onClick={() => toggleExapnd(creditNote)}>
                                <div className={creditNote.isExpanded === true ? "accordion-button active bg-dark" : "accordion-button collapsed"}>
                                    <div className="accordion-voucher-header">
                                        <b>{creditNote.voucherNumber}</b>
                                        {moment(creditNote.date).isSame(moment(), 'day') &&
                                            <div className='badge bg-success badge-small badge-notice'>Today</div>
                                        }
                                        {moment(creditNote.date).isSame(moment().add(-1, 'days'), 'day') &&
                                            <div className='badge bg-primary badge-small badge-notice'>Yesterday</div>
                                        }
                                        <div className='badge bg-success'>{currencyFormat(creditNote.amount)}/-</div>
                                        <div className="date-info">{moment(creditNote.date).format("DD MMM YYYY")}</div>
                                    </div>
                                </div>
                            </h2>
                            <div id={"c" + creditNote.id.toString()} className={creditNote.isExpanded === true ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby={"c" + creditNote.id.toString()}>
                                <div className="accordion-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">
                                            Amount
                                            <div className="fw-bold">{currencyFormat(creditNote.amount)}/-</div>
                                        </li>
                                        <li className="list-group-item">
                                            Notes
                                            <div className="fw-bold">{creditNote.notes}</div>
                                        </li>
                                    </ul>
                                    <div className="btn-group d-flex" role="group" style={{ marginTop: 10 }}>
                                        <div className="btn btn-dark w-100" title="View" onClick={() => viewCreditNoteData(creditNote)}>
                                            <FontAwesomeIcon icon={faFileInvoice} style={{ width: "auto" }} />
                                            &nbsp; Download Credit Note
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {receipts && receipts.map((receipt) => (
                        <div className="accordion-item">
                            <h2 className="accordion-header" id={receipt.id.toString()} onClick={() => toggleExapnd(receipt)}>
                                <div className={receipt.isExpanded === true ? "accordion-button active bg-dark" : "accordion-button collapsed"}>
                                    <div className="accordion-voucher-header">
                                        <b>{receipt.voucherNumber}</b>
                                        {moment(receipt.date).isSame(moment(), 'day') &&
                                            <div className='badge bg-success badge-small badge-notice'>Today</div>
                                        }
                                        {moment(receipt.date).isSame(moment().add(-1, 'days'), 'day') &&
                                            <div className='badge bg-primary badge-small badge-notice'>Yesterday</div>
                                        }
                                        <div className='badge bg-success'>{currencyFormat(receipt.amount)}/-</div>
                                        <div className="date-info">{moment(receipt.date).format("DD MMM YYYY")}</div>
                                    </div>
                                </div>
                            </h2>
                            <div id={"r" + receipt.id.toString()} className={receipt.isExpanded === true ? "accordion-collapse show" : "accordion-collapse collapse"} aria-labelledby={"r" + receipt.id.toString()}>
                                <div className="accordion-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">
                                            Date
                                            <div className="fw-bold">{moment(receipt.date).format("DD MMM YYYY")}</div>
                                        </li>
                                        <li className="list-group-item">
                                            Amount
                                            <div className="fw-bold">{currencyFormat(receipt.amount)}/-</div>
                                        </li>
                                        <li className="list-group-item">
                                            Ref No.
                                            <div className="fw-bold">{receipt.referenceNumber}</div>
                                        </li>
                                        <li className="list-group-item">
                                            Notes
                                            <div className="fw-bold">{receipt.notes}</div>
                                        </li>
                                    </ul>
                                    <div className="btn-group d-flex" role="group" style={{ marginTop: 10 }}>
                                        <div className="btn btn-dark w-100" title="View" onClick={() => viewReceiptData(receipt)}>
                                            <FontAwesomeIcon icon={faFileInvoice} style={{ width: "auto" }} />
                                            &nbsp; Download Receipt
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {(totalPages > pageNumber) &&
                    <>
                        {isLoading &&
                            <div className="btn btn-dark w-100 text-center mt-2">
                                <div className="spinner-border text-light" role="status">
                                </div>
                            </div>
                        }
                        {!isLoading &&
                            <div className="btn btn-outline-dark w-100 text-center mt-2" onClick={() => setPageNumber(pageNumber + 1)}>Load More...</div>
                        }
                    </>
                }
            </div>
        </div>
    );
};
